import { render } from "./Home.vue?vue&type=template&id=0d299b1c"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=0d299b1c&lang=css"

import exportComponent from "/home/jym/canvas_lms/lms/canvas/course_category_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__